import { forwardRef, type InputHTMLAttributes } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const input = tv({
  base: [
    'h-10 w-full rounded-md border bg-[var(--color-an-surface)] px-3 text-sm',
    'border-[var(--color-an-border)] text-[var(--color-an-text)]',
    'placeholder:text-[var(--color-an-text-muted)]',
    'focus-visible:outline-none focus-visible:border-[var(--color-an-primary)]',
    'disabled:cursor-not-allowed disabled:opacity-60',
  ].join(' '),
  variants: {
    invalid: {
      true: 'border-[var(--color-an-danger)]',
      false: '',
    },
  },
  defaultVariants: { invalid: false },
});

type InputVariants = VariantProps<typeof input>;

export type InputProps = InputHTMLAttributes<HTMLInputElement> & InputVariants;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...rest }, ref) => (
    <input
      ref={ref}
      className={input({ invalid, className })}
      aria-invalid={invalid ? true : undefined}
      data-invalid={invalid ? 'true' : undefined}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';
